import { type ComponentProps, forwardRef } from 'react';

import { XIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

export const CloseButton = forwardRef<HTMLButtonElement, ComponentProps<'button'>>(
  ({ className, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        'flex size-7 shrink-0 items-center justify-center rounded-sm bg-background-darker/40 text-text-secondary transition-colors hover:bg-background-darker/80 hover:text-primary-darker focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-light',
        className
      )}
      {...props}
    >
      <XIcon aria-hidden="true" className="size-4" />
    </button>
  )
);

CloseButton.displayName = 'CloseButton';
